// externals
import React from 'react';

// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import type { DealState } from '@makemydeal/dr-dash-types';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';

// consts
import { ADJUSTED_CAP_COST } from '../../constants';

// components
import DealSummaryItem from '../common/DealSummaryItem';

// hooks
import { createDealRootSelector } from '../../offerCompareColumn/hooks/createDealRootSelector';
import { useDealSummary } from '../../common/DealSummaryProvider';

// styles
import { detailedViewValueStyles } from '../utils/styles';
import { useHeldValue } from '../../hooks/useHeldSelector';

const AdjCapCost = ({ deal }: DealState) => {
    const useDealRootSelector = createDealRootSelector(deal, 'AdjCapCost');
    const adjustedCapCost = useHeldValue(useDealRootSelector(offerReduxSelectors.getAdjustedCapCost, 'adjustedCapCost'), deal);
    const formatted = formatDollarsAndCents(adjustedCapCost);
    const { showDetailedView } = useDealSummary();

    return (
        <DealSummaryItem
            label={ADJUSTED_CAP_COST}
            value={formatted}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default AdjCapCost;
